import axios from 'axios';
import { cleanRequestData } from '../../app/services/utilsServices';
// This is not really a 'promise factory' it is a function that returns a promise X_x

const getSuggestionsForSelect = (apiURL) => {
   return () => {
      return axios.get(`${ apiURL }`);
   };
};

const postPayload = (apiURL) => {
   return (payload = {}) => {
      const sanitizedPayload = cleanRequestData(payload);
      return axios.post(
         apiURL,
         sanitizedPayload,
      );
   };
};

const postPayloadWithFormCB = (apiURL, payload) => {
   return () => {
      const sanitizedPayload = cleanRequestData(payload);
      return axios.post(
         apiURL,
         sanitizedPayload,
      );
   };
};

const postPayloadAsParam = (apiURL, payload) => {
   return () => {
      const sanitizedPayload = cleanRequestData(payload);
      return axios.post(
         apiURL,
         sanitizedPayload,
      );
   };
};

export default {
   getSuggestionsForSelect,
   postPayload,
   postPayloadAsParam,
   postPayloadWithFormCB,
};

